export default "__VITE_ASSET__MjSVgm4w__"